import * as React from 'react';

type PressReleasesCardProps = {
  url: string;
  date: string;
  heading: string;
  description?: string;
};

const PressReleaseCard: React.FC<PressReleasesCardProps> = ({
  url,
  date,
  heading,
  description
}) => (
  <a href={url} className="release-card">
    <p className="release-card__date">{date}</p>
    <h3 className="release-card__heading">{heading}</h3>
    {description && <p className="release-card__description">{description}</p>}
  </a>
);
export default PressReleaseCard;
